import {
  faFacebookF,
  faInstagram,
  faTiktok,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { useMediaQuery } from "@mui/material";
import { useIntersectionObserver, useIsClient } from "@uidotdev/usehooks";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FacebookEmbed,
  InstagramEmbed,
  TikTokEmbed,
  XEmbed,
} from "react-social-media-embed";
import { FlexContainer, TextStyled } from "../styles";
import {
  CardContainer,
  CardStyled,
  DialogStyled,
  FontAwesomeIconStyled,
  PlayIconStyled,
  SkeletonContainer,
  SocialMediaWrapper,
} from "./styles";

function CompanySocialMedia(props) {
  const { companyDetail, setCurrentTab } = props || {};
  const { t } = useTranslation();
  const isClient = useIsClient();
  const isMobile = useMediaQuery("(max-width: 640px)");
  const socialMediaHighlights = Array.isArray(companyDetail)
    ? companyDetail
    : [];
  const hasScrollableLayout = socialMediaHighlights.length >= 5;
  const hasMoreThanTwoHighlights = socialMediaHighlights.length > 2;

  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    rootMargin: "-200px 0px -60% 0px",
  });

  useEffect(() => {
    if (entry?.isIntersecting && setCurrentTab) {
      setCurrentTab(4);
    }
  }, [entry?.isIntersecting, setCurrentTab]);

  return isClient ? (
    <SocialMediaWrapper
      aria-label={t("companydetail.social_media_section_aria")}
      id="CompanySocialMedia"
      ref={ref}
    >
      <TextStyled
        variant="h2"
        fontSize="1.25rem"
        fontWeight={700}
        textTransform="capitalize"
        aria-label={t("companydetail.social_media_section_title_aria")}
        color={"#000"}
        marginBottom={"2rem"}
        sx={{
          "@media (max-width: 1280px)": {
            padding: "0 1.5rem",
          },
          "@media (max-width: 640px)": {
            padding: "0 1rem",
          },
        }}
      >
        {t("companydetail.social_media_section_title")}
      </TextStyled>

      <div style={{ position: "relative", width: "100%" }}>
        {/* <ArrowContainer
          $isScrollable={hasScrollableLayout}
          $more={hasMoreThanTwoHighlights}
        >
          <TextStyled
            fontSize={
              isMobile
                ? hasMoreThanTwoHighlights
                  ? "1rem"
                  : "1.25rem"
                : "1rem"
            }
            lineHeight={"1.25rem"}
            letterSpacing={"0.15px"}
            fontStyle={"italic"}
          >
            click me!
          </TextStyled>
          <ArrowIcon
            $isScrollable={hasScrollableLayout}
            $more={hasMoreThanTwoHighlights}
          />
        </ArrowContainer> */}
        <CardContainer
          $isScrollable={hasScrollableLayout}
          justifyContent={hasMoreThanTwoHighlights ? "flex-start" : "flex-end"}
          tabIndex={hasScrollableLayout ? 0 : undefined}
        >
          {socialMediaHighlights.map((socialMedia, index) => (
            <SocialMediaCard
              isScrollableLayout={hasScrollableLayout}
              socialMedia={socialMedia}
              key={index}
            />
          ))}
        </CardContainer>
      </div>
    </SocialMediaWrapper>
  ) : (
    <SkeletonContainer />
  );
}

function SocialMediaCard(props) {
  const { isScrollableLayout, socialMedia } = props;

  const [open, setOpen] = useState(false);

  const link = socialMedia.socialMediaLink;

  function getSocialMediaType() {
    if (link.includes("facebook.com") || link.includes("fb.com")) {
      return "Facebook";
    } else if (link.includes("twitter.com") || link.includes("x.com")) {
      return "Twitter";
    } else if (link.includes("instagram.com")) {
      return "Instagram";
    } else if (link.includes("tiktok.com")) {
      return "Tiktok";
    }
  }

  const socialMediaType = getSocialMediaType();

  function handleCardClick() {
    if (socialMediaType === "Facebook") {
      if (typeof window !== "undefined" && link) {
        window.open(link, "_blank", "noopener,noreferrer");
      }
      return;
    }

    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function getSocialMediaIcon() {
    switch (socialMediaType) {
      case "Facebook":
        return <FontAwesomeIconStyled icon={faFacebookF} />;
      case "Twitter":
        return <FontAwesomeIconStyled icon={faXTwitter} />;
      case "Instagram":
        return <FontAwesomeIconStyled icon={faInstagram} />;
      case "Tiktok":
        return <FontAwesomeIconStyled icon={faTiktok} />;
      default:
        return;
    }
  }

  function getColorStyle() {
    switch (socialMediaType) {
      case "Facebook":
        return {
          backgroundColor: "#1877F2",
        };
      case "Twitter":
        return {
          backgroundColor: "#222",
        };
      case "Instagram":
        return {
          background:
            "linear-gradient(45deg, #FFC107 14.63%, #F44336 50.5%, #9C27B0 84.66%)",
        };
      case "Tiktok":
        return {
          backgroundColor: "#222",
        };
      default:
        return;
    }
  }

  return (
    <>
      <CardStyled
        $isScrollable={isScrollableLayout}
        sx={getColorStyle}
        onClick={handleCardClick}
      >
        {getSocialMediaIcon()}
        <FlexContainer
          flexDirection={"column"}
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <PlayIconStyled />
        </FlexContainer>
      </CardStyled>
      {socialMediaType !== "Facebook" && (
        <DialogStyled open={open} onClose={handleClose}>
          <SocialMediaEmbed url={link} type={socialMediaType} />
        </DialogStyled>
      )}
    </>
  );
}

function SocialMediaEmbed(props) {
  const { url, type } = props;

  if (type === "Facebook") {
    return <FacebookEmbed url={url} width={"400px"} />;
  }

  if (type === "Twitter") {
    return <XEmbed url={url} width={"auto"} />;
  }

  if (type === "Instagram") {
    return <InstagramEmbed url={url} width={"auto"} />;
  }

  if (type === "Tiktok") {
    return <TikTokEmbed url={url} width={"auto"} />;
  }

  return null;
}
export default CompanySocialMedia;
